var map = {
	"./1.svg": "3296",
	"./Steor-Icon-01.svg": "2134",
	"./Steor-Icon-02.svg": "7703",
	"./Steor-Icon-03.svg": "35a9",
	"./Steor-Icon-04.svg": "79e1",
	"./Steor-Icon-05.svg": "f676",
	"./Steor-Icon-06.svg": "5cc3",
	"./Steor-Icon-07.svg": "498d",
	"./Steor-Icon-08.svg": "db91",
	"./Steor-Icon-09.svg": "864e",
	"./Steor-Icon-10.svg": "62c4",
	"./Steor-Icon-11.svg": "92e8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7f56";